import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/w/$slug/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/w/$slug/inbox", params });
  },
});
